import { render, staticRenderFns } from "./Gauss.vue?vue&type=template&id=660adcfa&scoped=true&"
import script from "./Gauss.vue?vue&type=script&lang=js&"
export * from "./Gauss.vue?vue&type=script&lang=js&"
import style0 from "./Gauss.vue?vue&type=style&index=0&id=660adcfa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "660adcfa",
  null
  
)

export default component.exports